import { React, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import Button from '../../CommonFields/Button'
import { routesFrontend } from "../../RouterFiles/routes";
import { useNavigate } from "react-router";
import moment from 'moment';
import { toastInfo } from "../../../Utilities/toast";

const ScrimBox = ({ scrimData,onJoinScrimClick }) => {
    const navigate = useNavigate()
    const { t } = useTranslation();

    const totalPlayers = scrimData?.noOfPlayerCapacity || 0; // Example total number of players
    const joinedPlayers = scrimData?.noOfJoinedPlayer || 0; // Example number of players who have joined
    const remainingPlayers = totalPlayers - joinedPlayers;

    const percentage = (joinedPlayers / totalPlayers) * 100; // Calculate percentage

    return (
        <>
            {scrimData && scrimData?._id &&
                <div className={`tournament-card-container position-relative`}>
                    <div className="container tournament-card--wrap">
                        {/* Render the tournament card if data is available */}
                        <div className="tournament-card mb-4 pb-0" style={{ borderRadius: "20px 20px 20px 20px" }}>
                            <div className="card-body d-flex flex-column justify-content-between">
                                <div className="d-flex justify-content-between align-items-center">
                                    <div className="card-title">
                                                    {scrimData?.title.length > 18 ? (
                                        // scrolldelay="200" for delay marquee
                                        <marquee >
                                           {scrimData?.title}
                                        </marquee>
                                      ) : (
                                        scrimData?.title
                                      )}
                                        {/* {scrimData?.title} */}
                                        </div>
                                    <button className="btn rules-btn" style={{ width: "fit-content" }} onClick={() => {
                                        navigator.clipboard.writeText(
                                            scrimData?.shortCode
                                        );
                                        toastInfo('short code copied')
                                    }}>ID-{scrimData?.shortCode}</button>
                                </div>
                                <hr style={{margin:"0.5rem 0"}}></hr>
                                <div className="row mt-3">
                                    <div className="col-12">
                                        <div className="tournament-card-detail">
                                            {/* Tournament details */}
                                            <div className="row">
                                                <div className="col-12 tournament-card-box--wrap">
                                                    <div className="row">
                                                        <div className="col-3 tournament-card-box">
                                                            <div className="detail-item">
                                                                <div className="tournament-detail-label letter-spacing">{moment(scrimData?.date).format("DD/MM/YYYY")}</div>
                                                                <div className="tournament-detail-value">date</div>
                                                            </div>
                                                        </div>
                                                        <div className="col-3 tournament-card-box">
                                                            <div className="detail-item">
                                                                <div className="tournament-detail-label">{moment(scrimData?.time).format("hh:mm A")}</div>
                                                                <div className="tournament-detail-value">time</div>
                                                            </div>
                                                        </div>
                                                        {scrimData?.title1 && scrimData?.title1?.name && scrimData?.title1?.value &&
                                                            <div className="col-3 tournament-card-box">
                                                                <div className="detail-item">
                                                                    <div className="tournament-detail-label">
                                                                    {scrimData?.title1?.value.length > 8 ? (
                  
                                                                            <marquee >
                                                                             {scrimData?.title1?.value}
                                                                            </marquee>
                                                                        ) : (
                                                                            scrimData?.title1?.value
                                                                        )}
                                                                        {/* {scrimData?.title1?.value} */}
                                                                        </div>
                                                                    <div className="tournament-detail-value">
                                                                    {scrimData?.title1?.name.length > 8 ? (
                  
                                                                                <marquee >
                                                                                {scrimData?.title1?.name}
                                                                                </marquee>
                                                                            ) : (
                                                                                scrimData?.title1?.name
                                                                            )}
                                                                        {/* {scrimData?.title1?.name} */}
                                                                        </div>
                                                                </div>
                                                            </div>
                                                        }
                                                        {scrimData?.title2 && scrimData?.title2?.name && scrimData?.title2?.value &&
                                                            <div className="col-3 tournament-card-box">
                                                                <div className="detail-item">
                                                                    <div className="tournament-detail-label">
                                                                    {scrimData?.title2?.value.length > 11 ? (
                  
                                                                        <marquee >
                                                                        {scrimData?.title2?.value}
                                                                        </marquee>
                                                                    ) : (
                                                                        scrimData?.title2?.value
                                                                    )}
                                                                                                                                
                                                                        {/* {scrimData?.title2?.value} */}
                                                                        </div>
                                                                    <div className="tournament-detail-value">
                                                                    {scrimData?.title2?.name.length > 11 ? (
                  
                                                                            <marquee >
                                                                            {scrimData?.title2?.name}
                                                                            </marquee>
                                                                        ) : (
                                                                            scrimData?.title2?.name
                                                                        )}
                                                                        {/* {scrimData?.title2?.name} */}
                                                                        </div>
                                                                </div>
                                                            </div>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="mt-3">
                                    <div className="tournament-details-winnings ">
                                        <div className="d-flex justify-content-between">
                                            <p className="prize-info">winners <span className="tournament-prizepool">{scrimData?.noOfWinner}</span></p>
                                            <p className="join-info">hosted by <span className="tournament-prizepool">{scrimData?.hostedByName}</span></p>
                                            {/* {scrimData?.hostedBy === JSON?.parse(localStorage?.getItem("profile"))?.user_id &&
                                                <p className="private-scrim-manage-btn" onClick={()=>{
                                                    navigate(`/private-contest/manage-contest/${scrimData?._id}`)
                                                }}>manage</p>
                                            } */}
                                        </div>
                                    </div>
                                </div>
                                <div className="d-flex justify-content-between align-items-center mt-3">
                                    {/* Progress Bar */}
                                    <div className="progress" style={{ height: "6px", width: "100%" }}>
                                        <div className="progress-bar" role="progressbar" style={{
                                            width: `${percentage}%`, // Dynamically set width
                                            backgroundColor: "#9F6693", // Change color if 100%
                                        }}></div>
                                    </div>
                                </div>
                                <p className="progressbar-text mt-2">
                                    <div>{scrimData?.noOfJoinedPlayer} {scrimData?.noOfJoinedPlayer > 1 ? 'players' : 'player'} joined</div>
                                    <div>{scrimData?.noOfPlayerCapacity}</div>
                                </p>
                            </div>
                            {scrimData?.isJoined == false && remainingPlayers > 0 ? (
                                <button className="join-now-btn join-now-btn-1 mb-4" onClick={onJoinScrimClick}>{t('tournament_list.join_now')}</button>
                            ) : scrimData?.isJoined === false && remainingPlayers === 0 ? (
                                <button className="join-now-btn join-now-btn-1 mb-4">{t('tournament_list.full')}</button>
                            ) : (
                                <button className="join-now-btn join-now-btn-1 mb-4" onClick={() => navigate(`/private-contest/detail/${scrimData?._id}`)}>{t('tournament_list.joined')}</button>
                            )}
                        </div>
                    </div>
                </div>
            }
        </>
    );
}

export default ScrimBox;